import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { otherConfigOptionsAttributes, otherConfigOptionsAttributesFeature } from "../../mandatoryConfigs/configSetupScreen/widget/configBottomBar";
// import { FeatureSelectionOptionsContext } from "../../../../components/newPortal/NewPortalLayout";
import { FeatureSelectionOptionsContext } from "../../../settings/components/FeatureSelectionOptionsContext";
import "../feautreSelectionScreen.css";
import { Box, Button } from "@mui/material";
import feautreSelectionBg from "../../../../assets/image/png/feautre-selection-bg.png";

import PhoneFrameComponent from "../../../onboarding/PhoneFrame";
import NonActivatedCard from "./optionalFeautreNonActivatedCard";
import { OptionType } from "../../../manageHomepage/ManageHomePageTypes";
import { ImageIdToSVGMap } from "../../../../components/newPortal/UiConfigOptions";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faChevronUp, faChevronDown} from "@fortawesome/free-solid-svg-icons";
import { appSubscriptionCheck } from "../../../../services/uiConfigService";

export default function AnimatedContainer(props: {
  allConfigOptions: otherConfigOptionsAttributes[];
  setAllConfigOptions: React.Dispatch<
    React.SetStateAction<otherConfigOptionsAttributes[]>>;
  standard: string | undefined;
  currentRole: OptionType;
  setFeatureChangeList: React.Dispatch<React.SetStateAction<string[]>>
}) {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [flyingOption, setFlyingOption] =
    useState<otherConfigOptionsAttributes | null>(null); // To track the flying option
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [removingOption, setRemovingOption] = useState<string | null>(null);
  const [isOptionalActivated, setIsOptionalActivated] =
    useState<boolean>(false);

  const [selectedConfigImage, setSelectedConfigImage] =
    useState<string>(feautreSelectionBg);
  const [optionalConfigImage, setOptionalConfigImage] =
    useState<string>(feautreSelectionBg);
  
  const {
    uiConfigOptionsProp = [],
    setUiConfigOptionsProp = () => {},
  } = useContext(FeatureSelectionOptionsContext);
  const location=useLocation();
  const [existingFeatureDropdown,setExistingFeatureDropdown]=useState<Map<string,boolean>>(new Map())
  const [additionalFeatureDropdown,setAdditionalFeatureDropdown]=useState<Map<string,boolean>>(new Map())
  const isOnboarding = location.pathname.includes("onboarding");


  // useEffect(() => {
  //   props.setAllConfigOptions([...uiConfigOptionsProp]);
  // }, [uiConfigOptionsProp]);
  useEffect(()=>{
    const preExistingMap=new Map(existingFeatureDropdown);
    const preAdditionalMap=new Map(additionalFeatureDropdown);
    uiConfigOptionsProp.map((opt)=>{
      if(!preExistingMap.has(opt.id)) preExistingMap.set(opt.id,false)
   }) 
    props.allConfigOptions.map((opt)=>{
       if(!preAdditionalMap.has(opt.id)) preAdditionalMap.set(opt.id,false)
    })
  setExistingFeatureDropdown(preExistingMap)
  setAdditionalFeatureDropdown(preAdditionalMap)
   },[uiConfigOptionsProp])
  

  const handleAddOptions = () => {
    const optionsToAdd = [...selectedOptions];
        props.setFeatureChangeList((prev) => {
          for (let option of optionsToAdd) {
            const index = prev.indexOf(option);
            if (index !== -1) {
              prev.splice(index, 1);
            } else {
              prev.push(option);
            }
          }
          return [...prev];
        });
        setUiConfigOptionsProp((prevState:otherConfigOptionsAttributes[])=>
          prevState.map((prev:otherConfigOptionsAttributes)=>{ 
          const updatedSubfeature=  prev.subfeatures?.map((sub)=>selectedOptions.includes(sub.id)?{...sub,isSelected:true,action:"added"} as otherConfigOptionsAttributesFeature:sub)
            const hasAChild=updatedSubfeature?.some((sub)=>sub.isSelected===true)??false;
            return {
              ...prev,
              subfeatures:updatedSubfeature,
              hasASelectedChild:hasAChild
            };
          })
        )

        setSelectedOptions([]);
  };

  const handleCheckboxChange = (optionId: string) => {
    setSelectedOptions(
      (prev) =>
        prev?.includes(optionId)
          ? prev?.filter((id) => id !== optionId) // Remove if already selected
          : [...prev, optionId] // Add if not selected
    );
  };

  const handleRemoveOption = (option: otherConfigOptionsAttributes,subfeatures:otherConfigOptionsAttributesFeature) => {
    props.setFeatureChangeList((prev) => {
      const index = prev.indexOf(subfeatures.id);
      if (index !== -1) {
        prev.splice(index, 1);
      } else {
        prev.push(subfeatures.id);
      }
      return [...prev];
    });

    setRemovingOption(subfeatures.id);

    setTimeout(() => {
     setUiConfigOptionsProp((prev:otherConfigOptionsAttributes[])=>
             prev.map((feature)=>{
                 if(feature.id===option.id){
              const updatedSubfeature= feature.subfeatures?.map((sub)=>
                   sub.id===subfeatures.id?{...sub,isSelected:false,action:"removed"} as otherConfigOptionsAttributesFeature :sub)
              const hasAChild=updatedSubfeature?.some((sub)=>sub.isSelected===true)??false
              return {
                 ...feature,
                 subfeatures:updatedSubfeature,
                 hasASelectedChild:hasAChild
              }
                 }
           return feature;
         })
           )
      setRemovingOption(null);
    }, 400);
  };
  console.log(uiConfigOptionsProp)

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        justifyContent: "space-between",
        overflow:"hidden"
      }}
    >
      {/* Left side: Selected options */}
      <div className="selected-configuration-container" style={{height : !isOnboarding ? "73vh" : "78vh"}}>
        <div
          style={{
            flex: "7 1 0",
            borderRadius: "5px",
            padding: "15px",
            display: "flex",
            flexDirection: "row",
            height: !isOnboarding ? "97%" : "100%",
            gap:"2%"
          }}
        >
          <Box sx={{ width: "65%", height: "100%" }}>
            {" "}
            {/* Heading */}
            <div
              className="heading"
              style={{
                display: "flex",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "13px",
                  marginRight: "8px",
                  borderLeft: "#00c6b1 3px solid",
                  paddingLeft: "5px",
                }}
              >
                Your App Is Ready With Following Features
              </div>
            </div>
            {/* Content Container */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "scroll",
                height: "95%",
              }}
            >
              <>
                <div
                  style={{
                    flex: "2",
                    gridTemplateColumns: "repeat(3,1fr)",
                    rowGap: "15px",
                    gap: "10px",
                    padding: "4%",
                    listStyleType: "none",
                  }}
                >
                  {" "}
                  {uiConfigOptionsProp?.filter((config)=>config.hasASelectedChild).
                     map((option) => (
                      <div
                        key={option.id}
                        
                        style={{
                          width: "100%",
                          borderBottom: "1px solid #EFEFEF",
                          padding: "10px", // Padding around each item
                          marginBottom: "25px", // Space between each item
                        }}
                      >
                        <div
                          className="hover-button-container"
                         
                        >
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}} >
                           <div style={{display:"flex",rowGap:"8px",alignItems:"center"}} >
                          <div style={{ position: "relative" }}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: 60,
                                minHeight: 60,
                                boxSizing: "content-box",
                                marginRight: "6px",
                                borderRadius: 2,
                                backgroundColor: "#FFFFFF",
                                color: "#000",
                                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                  backgroundColor: "#FFFFFF",
                                  // border: !option.isSelected
                                  //   ? "1px solid #227C9D "
                                  //   : "0px solid #227C9D ",
                                },
                              }}
                            >
                              <img
                                // onClick={() =>
                                //   setSelectedConfigImage(option.hintImage)
                                // }
                                src={ImageIdToSVGMap[option.icon ?? "default"]}
                                alt={`${option.id} icon`}
                                style={{
                                  height: "30px", // Fixed height for icons
                                  width: "30px", // Fixed width for icons
                                  borderRadius: "5px", // Rounded corners for the image
                                }}
                              />
                            </Box>
                          </div>
                          <div style={{  marginLeft: "10px" }}>
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: "13px",
                                color: "#333",
                                marginBottom: "5px",
                              }}
                            >
                              {option.id}
                            </div>
                          </div>
                          </div>
                          
                           <FontAwesomeIcon
                                            icon={existingFeatureDropdown.has(option.id)&&existingFeatureDropdown.get(option.id)===true?faChevronUp:faChevronDown}
                                            onClick={() => {
                              const newMap = new Map(existingFeatureDropdown); 
                              newMap.set(option.id, !existingFeatureDropdown.get(option.id));
                              setExistingFeatureDropdown(newMap); 
                                            }
                                          }
                                            />
                        </div>
                        </div>

                                 { existingFeatureDropdown.get(option.id)&&option.subfeatures?.filter((opt)=>opt.isSelected).map((opt)=>(
                    <div  className={
                    removingOption === opt.id ? "exitAnimation" : ""
                  } style={{display:"flex",justifyContent:"space-between",alignItems:"center"}} >
                       <div
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#333333",
                        marginBottom: "4px",
                      }}
                    >
                      {opt.id}
                    </div>
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      backgroundColor:opt.isSelected?  "#10b981":"white",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: "16px",
                      cursor: "pointer",
                      marginBottom:"4px",
                    }}
                    onClick={() => handleRemoveOption(option,opt)}
                  >
                    { opt.isSelected&&(
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M10 3L4.5 8.5L2 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>)
}
                  </div>
                  </div>
                  ))
}
                      </div>
                    ))}
                
                </div>
              </>
            </div>
          </Box>
          <Box
            sx={{
              width: "35%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            {/* Image Section */}
            <PhoneFrameComponent
              allowTriggerChanges
              widthValue={"100%"}
              heightValue={"100%"}
            />
          </Box>
        </div>
      </div>

      {/* Right side: Non Mandatory options */}
      <div
        className={`optional-configuration-container ${
          isOptionalActivated ? `activated` : ""
        }`} style={{height : !isOnboarding ? "70vh" : "71vh"}}
      >
        {!isOptionalActivated ? (
          <>
            <NonActivatedCard setIsOptionalActivated={setIsOptionalActivated} />
          </>
        ) : (
          <>
          <div style={{
             display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative", // Add relative positioning for absolute positioning of sticky button
            height: "800px"
          }} >
            <div className="header-info"  >
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#20c997",
                
                }}
              >
                Advanced Features
              </h3>
            </div>
            <div
                       style={{
                         flex: "1",
                         overflowY: "auto",
                         padding: "24px 24px 24px 24px", // Add bottom padding to prevent overlap with sticky button
                         backgroundColor: "#ffffff",
                maxHeight:"500px"
                       }}
                     >
                       {props.allConfigOptions
                         // ?.filter(
                         //   (option) =>
                         //     !option.isMandatory &&
                         //     !option.isSelected
                         //     && appSubscriptionCheck(option,props.standard)
                         // )
                         ?.map((option,index) => (
                           <div
                             key={option.id}
                             style={{
                               alignItems: "center",
                               padding: index===0?"36px 0px 8px 0px": "16px 0px 8px 0px",
                               borderBottom: "1px solid #f0f0f0",
                               cursor: "pointer",
                             }}
                           
                           >
                              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}} >
                             {/* Feature Icon */}
                               <div style={{display:"flex",rowGap:"8px",alignItems:"center"}} >
                             <div
                               style={{
                                 width: "40px",
                                 height: "40px",
                                 backgroundColor: "#f8f9fa",
                                 borderRadius: "8px",
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 marginRight: "16px",
                                 border: "1px solid #e0e0e0",
                               }}
                             >
                               <img
                                 src={ImageIdToSVGMap[option.icon ?? "default"]}
                                 alt={`${option.id} icon`}
                                 style={{
                                   width: "20px",
                                   height: "20px",
                                 }}
                               />
                             </div>
         
                             {/* Feature Info */}
         
                               <div
                                 style={{
                                   fontSize: "14px",
                                   fontWeight: 500,
                                   color: "#333333",

                                 }}
                               >
                                 {option.id}
                               </div>
                             </div>
                                               <FontAwesomeIcon
                           icon={additionalFeatureDropdown.has(option.id)&&additionalFeatureDropdown.get(option.id)===true?faChevronUp:faChevronDown}
                           onClick={() => {
             const newMap = new Map(additionalFeatureDropdown); 
             newMap.set(option.id, !additionalFeatureDropdown.get(option.id));
             setAdditionalFeatureDropdown(newMap); 
                           }
                         }
                           />
                             </div>
         
                             {/* Checkbox */}
                              {additionalFeatureDropdown.get(option.id)&&option.subfeatures?.filter((opt)=>!opt.isSelected).map((opt)=>(
                             <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}} >
                                <div
                               style={{
                                 fontSize: "14px",
                                 fontWeight: 500,
                                 color: "#333333",
                                 marginBottom: "4px",
                               }}
                             >
                               {opt.id}
                             </div>
                             <div
                               style={{
                                 width: "20px",
                                 height: "20px",
                                 backgroundColor: selectedOptions.includes(opt.id) ? "#10b981" : "#ffffff",
                                 borderRadius: "4px",
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 marginLeft: "16px",
                                 border: selectedOptions.includes(opt.id) ? "none" : "2px solid #e0e0e0",
                                 cursor: "pointer",
                               }}
                               onClick={(e) => {
                                 e.stopPropagation();
                                 handleCheckboxChange(opt.id);
                               }}
                             >
                               {selectedOptions.includes(opt.id) && (
                                 <svg
                                   width="12"
                                   height="12"
                                   viewBox="0 0 12 12"
                                   fill="none"
                                 >
                                   <path
                                     d="M10 3L4.5 8.5L2 6"
                                     stroke="white"
                                     strokeWidth="2"
                                     strokeLinecap="round"
                                     strokeLinejoin="round"
                                   />
                                 </svg>
                               )}
                             </div>
                             </div>))}
                           </div>
                         ))}
                     </div>
         
                     {/* Sticky Add Button and Preview Link - Now absolutely positioned */}
                     <div
                       style={{
                    
        backgroundColor: "#ffffff",
                padding: "8px 8px 0px 8px",
                borderTop: "1px solid #f0f0f0",
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "flex-end",
                alignItems: "center"
                       }}
                     >
                       {selectedOptions.length > 0 && (
                         <button
                           onClick={handleAddOptions}
                           style={{
                             backgroundColor: "#10b981",
                             color: "#ffffff",
                             border: "none",
                             padding: "12px 0px",
                             marginLeft: "auto",
                             borderRadius: "8px",
                             fontSize: "14px",
                             fontWeight: 500,
                             cursor: "pointer",
                             transition: "all 0.2s ease",
                             minWidth: "120px"
                           }}
                           onMouseOver={(e) => {
                             e.currentTarget.style.backgroundColor = "#059669";
                           }}
                           onMouseOut={(e) => {
                             e.currentTarget.style.backgroundColor = "#10b981";
                           }}
                         >
                           Add ({selectedOptions.length})
                         </button>
                       )}
                 
                     </div>
                     </div>
          </>
        )}
      </div>
    </div>
  );
}
